import api from 'api';

const getQuoteDetail = async ({ ticketId, quoteId }) => {
  const data = await api.get(
    `price-negotiation/tickets/${ticketId}/quotes/${quoteId}/`
  );
  return data;
};

export default getQuoteDetail;
